import React from 'react';
import { ActivityIcon, HeartIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
export const TherapySection: React.FC = () => {
  return <section className="py-16 md:py-24 therapy-section" data-id="element-299">
      <div className="section-container" data-id="element-300">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-301">
          <div className="space-y-6" data-id="element-302">
            <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper" data-id="element-303">
              The right therapy for every person.
            </h2>
            <p className="text-lg text-plum-gray leading-relaxed" data-id="element-304">
              Our licensed trauma therapists deliver the evidence-based care we work with you to fit your needs and your style — including EMDR,
              CBT, CPT, and DBT — selected and guided by our Smart Intake System
              for your unique needs.
            </p>
          </div>
          <div className="flex items-center justify-center" data-id="element-305">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/avhDxZearHgP4AhdM6w6DE/connection_figures.svg" alt="Two human silhouettes holding hands, surrounded by circular halos representing connection and therapeutic support" className="w-full max-w-md" data-id="element-306" />
          </div>
        </div>
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-id="element-307">
          <div className="flex flex-col items-center text-center space-y-3" data-id="element-308">
            <div className="w-12 h-12 rounded-full bg-mist-sage/30 flex items-center justify-center" data-id="element-309">
              <ActivityIcon className="text-deep-juniper" size={24} data-id="element-310" />
            </div>
            <p className="font-medium" data-id="element-311">Smart Intake</p>
          </div>
          <div className="flex flex-col items-center text-center space-y-3" data-id="element-312">
            <div className="w-12 h-12 rounded-full bg-apricot/30 flex items-center justify-center" data-id="element-313">
              <HeartIcon className="text-deep-juniper" size={24} data-id="element-314" />
            </div>
            <p className="font-medium" data-id="element-315">Personalized Plan</p>
          </div>
          <div className="flex flex-col items-center text-center space-y-3" data-id="element-316">
            <div className="w-12 h-12 rounded-full bg-rejoy-coral/30 flex items-center justify-center" data-id="element-317">
              <UsersIcon className="text-deep-juniper" size={24} data-id="element-318" />
            </div>
            <p className="font-medium" data-id="element-319">Community Sessions</p>
          </div>
          <div className="flex flex-col items-center text-center space-y-3" data-id="element-320">
            <div className="w-12 h-12 rounded-full bg-sandstone/50 flex items-center justify-center" data-id="element-321">
              <TrendingUpIcon className="text-deep-juniper" size={24} data-id="element-322" />
            </div>
            <p className="font-medium" data-id="element-323">Continuous Healing</p>
          </div>
        </div>
      </div>
    </section>;
};